import React from 'react'

import "./button.css"

const Button = () => {
    return( <button className="list-button">Apply</button>)
}

export default Button